document.addEventListener('DOMContentLoaded', function () {
  const loadingSpinner = document.querySelector('[data-loading-spinner]');
  const profileFormContainer = document.querySelector('[data-profile-form]');
  const profileFormParent = document.querySelector('[data-form-parent]');

  if (!!profileFormParent) {
    const profileModal = document.getElementById('profileModal');
    const modalBody = profileModal.querySelector('[data-modal-body]');
    const submitButton = document.querySelector('[data-submit-button]');
    const classDisplayNone = 'd-none';

    function handleLabel() {
      const container = profileForm.querySelector('[data-handle-label]');
      if (!!container) {
        const inputs = container.getElementsByTagName('input');
        [...inputs].forEach(function (input) {
          if (!!input.value) {
            if (input.id.includes('-clone')) {
              input.id = input.id.replace(/-clone/, '');
              let label = input.nextSibling;
              label.setAttribute('for', input.id);
              return;
            }
            input.id += '-clone';
            let label = input.nextSibling;
            label.setAttribute('for', input.id);
          }
        });
      }
    }

    const profileFormId = profileFormParent.children[0].id;
    const profileForm = document.getElementById(profileFormId);
    profileModal.addEventListener('shown.bs.modal', function (event) {
      modalBody.appendChild(profileForm);
      if (profileModal.contains(profileForm)) {
        loadingSpinner.classList.add(classDisplayNone);
      }
      profileFormContainer.appendChild(profileForm.cloneNode(true));
      handleLabel();
      if (document.querySelector('[data-submit-button]')) {
        submitButton.classList.add('float-end', 'w-50');
      }
    });

    profileModal.addEventListener('hidden.bs.modal', function (event) {
      handleLabel();
      if (document.querySelector('[data-submit-button]')) {
        submitButton.classList.remove('float-end', 'w-50');
      }
      loadingSpinner.classList.remove(classDisplayNone);
      profileFormContainer.innerHTML = '';
      profileFormContainer.appendChild(profileForm);
    });
  }
});
